export default {
    en: {
        breadcrumb: 'RSD Proxy',
    },
    vi: {
        breadcrumb: 'Proxy dân cư',
    }
}